import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SupportForm from './components/SupportForm';
import HomeScreen from './components/HomeScreen';
import AquaticSpacePrivacyPolicy from './components/AquaticSpacePrivacyPolicy';
import KDartsPrivacyPolicy from './components/KDartsPrivacyPolicy';
import GingeryShotsPrivacyPolicy from './components/GingeryShotsPrivacyPolicy';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/support" element={<SupportForm />} />
        <Route path="/aquatic-space-privacy-policy" element={<AquaticSpacePrivacyPolicy />} />
        <Route path="/k-darts-privacy-policy" element={<KDartsPrivacyPolicy />} />
        <Route path="/gingery-shots-privacy-policy" element={<GingeryShotsPrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
